<template>
  <div class="hl-widget" @click="toggleMinimize()">
    <div class="hl-widget-progress-bar">
      <div class="hl-widget-progress-fill" :class="{ 'hl-widget-progress-fill-success': getTotalPercent === 100 }" :style="{ width: `${getTotalPercent || 0}%` }">
        <div class="hl-widget-progress-text-white">
          <span>{{ Math.round(getTotalPercent) || 0 }}%</span>
        </div>
      </div>

      <div class="hl-widget-progress-text">{{ Math.round(getTotalPercent) || 0 }}%</div>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { mapActions, mapGetters } from 'vuex'

  export default defineComponent({
    name: 'HardLoadingWidget',
    computed: {
      ...mapGetters({
        getTotalPercent: 'hardLoading/getTotalPercent'
      })
    },
    methods: {
      ...mapActions({
        changeMinimize: 'hardLoading/changeMinimize'
      }),
      toggleMinimize() {
        this.changeMinimize(false)
      }
    }
  })
</script>